export const LOGIST_WINDOW_TYPES = Object.freeze({
  BOSS: "Boss",
  INCOMING: "Incoming",
  APPOINTED: "Appointed",
  LOGIST: "Logist",
  DISTRIBUTED: "Distributed",
  FACTORY: "Factory",
  TP_LIST_FACTORY: "TpList Factory",
  FACTORY_CREATING_CARGO: "Factory Creating Cargo",
  FACTORY_CARGO: "Factory Cargo",
  SLEEPING: "Sleeping",
  SLEEPING_IN_SP: "Sleeping in SP",
  TRANSPORTER: "Transporter",
  TP_LIST_TRANSPORTER: "TpList Transporter",
  WAREHOUSE: "Warehouse",
  WAREHOUSE_COMING: "Warehouse coming",
  TP_LIST_WAREHOUSE: "TpList Warehouse",
});
